import { days } from "../constants/days";
import { Service } from "../types/entities";

export const mapSchedules = (service: Service, time: Date | null) => {
	//I get all the values: hours and store them in an array
	let allTimes;
	if (time) {
		const dayOfWeek = days[time.getDay()]; // 0 (Domingo) - 6 (Sábado)
		allTimes = service.schedule[dayOfWeek] ? service.schedule[dayOfWeek] : [];
	} else {
		allTimes = Object.values(service.schedule).flat();
	}

	const crossesMidnight = allTimes[0] > allTimes[allTimes.length - 1];

	const startDate = new Date(`01/01/2024 ${allTimes[0]}`);
	const endDate = new Date(
		`${crossesMidnight ? "01/02/2024" : "01/01/2024"} ${allTimes[allTimes.length - 1]}`
	);

	return generateSchedules(startDate, endDate);
};

export const generateSchedules = (startDate: Date, endDate: Date): string[] => {
	const schedules: string[] = [];

	// Set the interval to 30 minutes
	const interval = 30 * 60 * 1000;

	let currentTime = startDate.getTime();
	const toTime = endDate.getTime();

	// Generate schedules while the current time is less than the end time
	while (currentTime <= toTime) {
		// Convert the current time to a time string in HH:MM format
		const timeString = new Date(currentTime).toLocaleTimeString("es-ES", {
			hour: "2-digit",
			minute: "2-digit",
		});

		// Add the schedule to the schedules array
		schedules.push(timeString);

		// Add 30 minutes to the current time
		currentTime += interval;
	}

	return schedules;
};
